import { Skeleton } from '@/components/ui'
import { t } from '@/lib/i18n'

/** Route level loading placeholder that matches the final layout (never a lone spinner). */
export function PageSkeleton({ variant = 'feed' }: { variant?: 'feed' | 'grid' | 'blank' | 'page' }) {
  if (variant === 'blank') return <div className="min-h-dvh bg-page" aria-busy="true" />
  if (variant === 'grid') {
    return (
      <div aria-busy="true" aria-label={t('Loading')} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="overflow-hidden rounded-card border border-line bg-surface">
            <Skeleton className="aspect-video w-full rounded-none" />
            <div className="space-y-2 p-4">
              <Skeleton height={16} className="w-3/4" />
              <Skeleton height={12} className="w-1/2" />
            </div>
          </div>
        ))}
      </div>
    )
  }
  return (
    <div aria-busy="true" aria-label={t('Loading')} className={variant === 'page' ? 'mx-auto w-full max-w-[1080px] space-y-4 px-4 pt-6 lg:px-6' : 'space-y-4'}>
      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className="flex gap-3 rounded-card border border-line bg-surface p-4">
          <Skeleton shape="circle" width={40} height={40} />
          <div className="flex-1 space-y-2 pt-1">
            <Skeleton height={14} className="w-2/5" />
            <Skeleton height={12} className="w-4/5" />
            <Skeleton height={12} className="w-3/5" />
          </div>
        </div>
      ))}
    </div>
  )
}
